"use client";
import React from "react";
import { Accordion, AccordionItem } from "@heroui/accordion";

export default function AWIDisclaimer() {
  return (
    <Accordion className="mb-10" variant="bordered">
      <AccordionItem key="1" title="Disclaimer">
        The opinions expressed in this report are the true opinions of the
        analyst(s) about any companies and industries mentioned. Any “forward
        looking statements” are our best estimates and opinions based upon
        information that is publicly available and that we believe to be
        correct, but we have not independently verified with respect to truth or
        correctness. There is no guarantee that our forecasts will materialize.
        Actual results will likely vary.{" "}
        <strong>
          {" "}
          The companies listed above are covered by FRC under an issuer-paid
          model, where fees have been paid to FRC to commission this report and
          research coverage. This creates a potential conflict of interest which
          readers should consider.{" "}
        </strong>
        Distribution procedure: our reports are distributed first to our
        web-based subscribers on the date shown on this report then made
        available to delayed access users through various other channels for a
        limited time. To subscribe for real-time access to research, visit
        https://www.researchfrc.com/plans for subscription options. This report
        contains “forward looking” statements. Forward-looking statements
        regarding the Company, industry, and/or stock’s performance inherently
        involve risks and uncertainties that could cause actual results to
        differ from such forward-looking statements. Factors that would cause or
        contribute to such differences include, but are not limited to,
        continued acceptance of the Company’s products/services in the
        marketplace; acceptance in the marketplace of the Company’s new product
        lines/services; competitive factors; new product/service introductions
        by others; technological changes; dependence on suppliers; systematic
        market risks and other risks discussed in the Company’s periodic report
        filings, including interim reports, annual reports, and annual
        information forms filed with the various securities regulators. By
        making these forward-looking statements, Fundamental Research Corp. and
        the analyst/author of this report undertakes no obligation to update
        these statements for revisions or changes after the date of this report.
        Fundamental Research Corp DOES NOT MAKE ANY WARRANTIES, EXPRESSED OR
        IMPLIED, AS TO RESULTS TO BE OBTAINED FROM USING THIS INFORMATION AND
        MAKES NO EXPRESS OR IMPLIED WARRANTIES OR FITNESS FOR A PARTICULAR USE.
        ANYONE USING THIS REPORT ASSUMES FULL RESPONSIBILITY FOR WHATEVER
        RESULTS THEY OBTAIN FROM WHATEVER USE THE INFORMATION WAS PUT TO. ALWAYS
        TALK TO YOUR FINANCIAL ADVISOR BEFORE YOU INVEST. WHETHER A STOCK SHOULD
        BE INCLUDED IN A PORTFOLIO DEPENDS ON ONE’S RISK TOLERANCE, OBJECTIVES,
        SITUATION, RETURN ON OTHER ASSETS, ETC. ONLY YOUR INVESTMENT ADVISOR WHO
        KNOWS YOUR UNIQUE CIRCUMSTANCES CAN MAKE A PROPER RECOMMENDATION AS TO
        THE MERIT OF ANY PARTICULAR SECURITY FOR INCLUSION IN YOUR PORTFOLIO.
        This REPORT is solely for informative purposes and is not a solicitation
        or an offer to buy or sell any security. It is not intended as being a
        complete description of the company, industry, securities or
        developments referred to in the material. Any forecasts contained in
        this report were independently prepared unless otherwise stated, and
        HAVE NOT BEEN endorsed by the Management of the company which is the
        subject of this report. Additional information is available upon
        request. THIS REPORT IS COPYRIGHT. YOU MAY NOT REDISTRIBUTE THIS REPORT
        WITHOUT OUR PERMISSION. Please give proper credit, including citing
        Fundamental Research Corp and/or the analyst, when quoting information
        from this report. The information contained in this report is intended
        to be viewed only in jurisdictions where it may be legally viewed and is
        not intended for use by any person or entity in any jurisdiction where
        such use would be contrary to local regulations or which would require
        any registration requirement within such jurisdiction.
      </AccordionItem>
    </Accordion>
  );
}
